import axios from 'axios'

import {
  createUnauthorizedAxiosResponse,
  handleUnauthorizedResponse,
} from './unauthorizedSession'

export function setupAuthGuards() {
  if (typeof window === 'undefined') {
    return
  }

  if (window.__authAxiosInterceptorInstalled) {
    return
  }

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (handleUnauthorizedResponse(error)) {
        // Resolve instead of reject so service .catch blocks with
        // window.location.reload() never run on 401.
        return Promise.resolve(createUnauthorizedAxiosResponse(error))
      }

      return Promise.reject(error)
    },
  )

  window.__authAxiosInterceptorInstalled = true
}
